import styled from "styled-components";

import { Box, Button, Card } from "@mui/material";
import Colors from "@constants/Colors";

export const CustomCard = styled(Card)`
  &.MuiPaper-root {
    border: none;
    box-shadow: none;
    background: ${Colors.white};
    background-color: inherit;
    padding: 8px;
  }
`;

export const CustomCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CustomCardHeaderTitle = styled(Box)<{
  color: string;
  $hideViewAllButton: boolean;
}>`
  font-family: Ringside Regular-Bold;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: ${(props) => props.color};

  ${(props) => props.$hideViewAllButton && "margin-bottom: 6px;"}
`;

export const CardButtonWrapper = styled(Button)`
  margin: 10px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const CardButtonText = styled.div<{
  leftMargin: string;
}>`
  font-family: Ringside Regular-Bold;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  text-transform: capitalize;
  color: ${Colors.primary};
  margin-left: ${(props) => props.leftMargin}px;
`;
